<template>
  <div class="dt-list v2" v-if="booking && booking.promoter_related_contacts && booking.promoter_related_contacts.length > 0">
    <div class="dt-list-item" v-for="(contact, index) of booking.promoter_related_contacts" :key="index">
      <div class="dt-list-item--column pad--5">{{ contact.contact }}</div>
      <div class="dt-list-item--column pad--5">{{ contact.relation }}</div>
      <div class="dt-list-item--column contact-options">
        <div class="dt-icon-container">
          <img src="static/icons/phone.svg" class="dt-icon v5 s1" alt="Call" :title="contact['phone1']" :class="{ inactive: !contact['phone1'] }" @click="(e) => callContact(contact, e)" />
        </div>
        <div class="dt-icon-container">
          <img src="static/icons/email/email-grey.svg" class="dt-icon v5 s1" alt="Email" :title="contact['email1']" :class="{ inactive: !contact['email1'] }" @click="(e) => mailContact(contact, e)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openWindow, sendMail } from "../../../../utility";

export default {
  components: {},
  props: ["booking"],
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    callContact: function (contact, e) {
      const { phone1, phone2 } = contact;

      if (phone1 || phone2) {
        // openWindow(`tel:${contact["phone1"]}`);
        const phone = phone1 ? phone1 : phone2;
        window.open(`tel:${phone}`);
        e.stopPropagation();
      }
    },
    mailContact: function (contact, e) {
      if (contact["email1"]) {
        sendMail({
          mails: [contact["email1"]],
        });
        e.stopPropagation();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dt-list {
  width: 350px;
  padding-top: 5px;
  margin:10px 0 10px 0;
  border-top: 1px solid var(--bc-accent);

  .dt-list-item {
    // cursor: pointer;
    height: 30px;
    .dt-list-item--column {
      padding: 0px 8px;

      &:nth-child(1) {
        flex: 2.5;
      }
      &:nth-child(2) {
        flex: 1.8;
      }

      &.contact-options {
        display: flex;
      }
    }
  }
}
</style>

